export const dateFormat = (date, lang) => {
  const formatted = new Date(date)
  return `${formatted.toLocaleString(lang, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })}`
}
